import React from "react";

function useOutsideAlerter(ref: any, setX: any): void {
  React.useEffect(() => {
    /**
     * Alert if clicked on outside of element
     */
    // function handleClickOutside(event: React.MouseEvent<HTMLElement>) {
    function handleClickOutside(event: any) {
      if (ref.current && !ref.current.contains(event.target)) {
        setX(false);
      }
    }
    // Bind the event listener
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [ref, setX]);
}

const Dropdown = (props: {
  button: JSX.Element;
  children: JSX.Element;
  classNames: string;
  animation?: string;
  isOpen?: boolean;
  setIsOpen?: (open: boolean) => void;
  wrapperClassName?: string;
}) => {
  const {
    button,
    children,
    classNames,
    animation,
    isOpen,
    setIsOpen,
    wrapperClassName,
  } = props;
  const wrapperRef = React.useRef(null);

  // Use internal state if not controlled by parent
  const [internalOpen, setInternalOpen] = React.useState(false);

  // Determine which state and setter to use
  const openWrapper = isOpen !== undefined ? isOpen : internalOpen;
  const setOpenWrapper = setIsOpen !== undefined ? setIsOpen : setInternalOpen;

  useOutsideAlerter(wrapperRef, setOpenWrapper);

  return (
    <div
      ref={wrapperRef}
      className={`relative flex ${wrapperClassName || ""}`}
    >
      <div
        className="flex cursor-pointer"
        onMouseDown={() => setOpenWrapper(!openWrapper)}
      >
        {button}
      </div>
      <div
        className={`${classNames} absolute z-10 ${
          animation
            ? animation
            : "origin-top-right transition-all duration-300 ease-in-out"
        } ${openWrapper ? "scale-100" : "scale-0"}`}
      >
        {children}
      </div>
    </div>
  );
};

export default Dropdown;
